module.exports = [
  //   {
  //     __typename: 'WpPage_Pagebuilder_Layouts_ImageText',
  //     kicker: 'LeadBoxer Features',
  //     heading: 'Everything you need to start generating insights',
  //     text: `<p class="text-xl">
  //     Our platform is designed to work with many different sources of
  //     data.
  //   </p>
  //   <p>
  //     It has built-in features to enrich company (or personal) data,
  //     allows you to qualify prospects based on behaviour and profile data,
  //     and includes powerful filters and intuitive scoring algorithms to
  //     create segments.
  //   </p>
  //   <p>
  //     The results can then be synchronised or exported towards many
  //     destinations using existing integrations or via custom-built
  //     solutions.
  //   </p>`,
  //     buttons: [
  //       {
  //         label: 'Schedule a call',
  //         type: 'primary',
  //         destination: {
  //           __typename: 'WpPage',
  //           uri: 'https://www.leadboxer.com/demo/',
  //         },
  //       },
  //       {
  //         label: 'Start a trial',
  //         type: 'text',
  //         destination: {
  //           __typename: 'WpPage',
  //           uri: '/start/',
  //         },
  //       },
  //     ],
  //     image: {
  //       align: 'right',
  //       background: false,
  //       altText: '',
  //       title: 'leadboxer-features-illustration',
  //       description: '',
  //     },
  //   },
  //   // Temp
  //   {
  //     __typename: 'WpPage_Pagebuilder_Layouts_TempFeatures',
  //   },
  //   {
  //     __typename: 'WpPage_Pagebuilder_Layouts_ImageText',
  //     kicker: 'Track Lead Behaviour',
  //     heading: 'Website & email tracking',
  //     text: `
  //       <p class="text-xl">
  //         LeadBoxer enables you to track every digital action, click, view, download, and other touch-points from your audience and access this data in either raw unprocessed format or through our application.
  //       </p>
  //       <p>
  //        Capture a tremendous amount of behavioural data, including your lead’s entire interaction with your company starting with their first visit, all the pages they’ve viewed, all the emails they’ve opened, and all of the links they’ve clicked over time.
  //       </p>
  // `,
  //     buttons: [
  //     ],
  //     image: {
  //       align: 'right',
  //       background: false,
  //       altText: '',
  //       title: 'mail-tracking',
  //       description: '',
  //     },
  //   },
  //   {
  //     __typename: 'WpPage_Pagebuilder_Layouts_ImageText',
  //     kicker: 'Lead Identification',
  //     heading: 'Identify website visitors',
  //     text: `
  //       <p class="text-xl">
  //         LeadBoxer identifies both companies and individuals visiting your website.
  //       </p>
  //       <p>Identification of companies and organisations happens out of the box based on IP addresses, form fields, email and other touch-points.</p>\
  //       <p>Identifying individuals on your website can be achieved by utilising one or multiple of our integrations that capture individual data.</p>
  // `,
  //     buttons: [
  //     ],
  //     image: {
  //       align: 'left',
  //       background: false,
  //       altText: '',
  //       title: 'mail-tracking',
  //       description: '',
  //     },
  //   },
  //   {
  //     __typename: 'WpPage_Pagebuilder_Layouts_ImageText',
  //     kicker: 'Industry Data',
  //     heading: 'Enriched firmographic data',
  //     text: `
  //       <p class="text-xl">All Identified Leads are automatically.</p>
  //       <p>They are matched to various company database sources en enriched with their firmographic data such as industry, location, size, domain, social profiles, and many more data points.</p>
  //       <p><strong>Bring your own data</strong>. You can add and enrich all profiles with your own data by using our integrations and/or connectors.</p>
  //     `,
  //     buttons: [
  //     ],
  //     image: {
  //       align: 'right',
  //       background: false,
  //       altText: '',
  //       title: 'mail-tracking',
  //       description: '',
  //     },
  //   },
  //   {
  //     __typename: 'WpPage_Pagebuilder_Layouts_ImageText',
  //     kicker: 'Account Base Marketing',
  //     heading: 'Accounts view for ABM',
  //     text: `
  //       <p class="text-xl">The accounts view provides insights into 2 or more individuals or leads within the organisations that you are targeting.</p>
  //       <p>Group individual leads from the same company and ranking them by their combined score.</p>
  //       <p>This is particularly useful if your sales and marketing efforts need to focus on a group of people instead of one single lead, aka Account Based Marketing / Sales.</p>
  //     `,
  //     buttons: [
  //     ],
  //     image: {
  //       align: 'left',
  //       background: false,
  //       altText: '',
  //       title: 'mail-tracking',
  //       description: '',
  //     },
  //   },
  //   {
  //     __typename: 'WpPage_Pagebuilder_Layouts_ImageText',
  //     kicker: 'Segments your Leads',
  //     heading: 'Create Segments with filters',
  //     text: `
  //       <p class="text-xl">Use filters to remove noise, make selections, and focus on your target customers (which you can save as segments).</p>
  //       <p>Filter on profile data such as company name, industry or size, geographic data, behaviour; pages viewed, URLs, exit links or visits, and marketing data such as UTM tags or referrer.</p>
  //     `,
  //     buttons: [
  //     ],
  //     image: {
  //       align: 'right',
  //       background: false,
  //       altText: '',
  //       title: 'mail-tracking',
  //       description: '',
  //     },
  //   },
  //   {
  //     __typename: 'WpPage_Pagebuilder_Layouts_ImageText',
  //     kicker: 'Lead-scoring',
  //     heading: 'Automatic Lead-scoring',
  //     text: `
  //       <p class="text-xl">LeadBoxer automatically calculates a lead’s lead score based on the criteria that matters to you the most.</p>
  //       <p>We establish which leads or customers are relevant / important based on properties and behaviour.</p>
  //       <p>Fully Customisable, calculated On-the-fly, and adjustable for individuals. With LeadBoxer, there’s no manual work needed to identify “hot” leads. </p>
  //     `,
  //     buttons: [
  //     ],
  //     image: {
  //       align: 'left',
  //       background: false,
  //       altText: '',
  //       title: 'mail-tracking',
  //       description: '',
  //     },
  //   },
  //   {
  //     __typename: 'WpPage_Pagebuilder_Layouts_ImageText',
  //     kicker: 'Notifications',
  //     heading: 'Get Email Notifications',
  //     text: `
  //       <p class="text-xl">Receive notifications or updates for specific leads or customers visiting your site or reading emails.</p>
  //       <p>Get a message when MQL’s are identified or when a lead is Ready-To-Buy. Get individual leads or weekly account based overviews, that are ideal for Account Based Marketing (ABM) teams. Set custom scheduling, based on custom filters (segments) and routing to relevant team members in CSV, PDF or email format.</p>
  //     `,
  //     buttons: [
  //     ],
  //     image: {
  //       align: 'right',
  //       background: false,
  //       altText: '',
  //       title: 'mail-tracking',
  //       description: '',
  //     },
  //   },
  //   {
  //     __typename: 'WpPage_Pagebuilder_Layouts_Features',
  //     kicker: 'Even more Features',
  //     heading: 'Everything you need to take the most out of LeadBoxer',
  //     features: [
  //       {
  //         icon: 'RiGitMergeLine',
  //         heading: 'Integrations & Connectors',
  //         text: `We support many integrations out-of-the-box, to collect your data and get the results in your workflow.`,
  //       },
  //       {
  //         icon: 'RiGitBranchLine',
  //         heading: 'Flexible',
  //         text: `Built with flexibility in mind, we support various  workflows, data-sources, destinations and tool-stacks.`,
  //       },
  //       {
  //         icon: 'RiPencilLine',
  //         heading: 'Application & API',
  //         text: `You can use our modern (web) application or get the (raw) data through our world-class API.`,
  //       },
  //       {
  //         icon: 'RiPencilLine',
  //         heading: 'Full Data Search',
  //         text: `Quickly search through all lead data to quickly find the information you need. Like Google, but with your data.`,
  //       },
  //       {
  //         icon: 'RiGitMergeLine',
  //         heading:
  //           'Campaign Tracking <small class="text-gray-400 font-normal tracking-wide text-sm">(UTM TAGS)</small>',
  //         text: `See, filter and score for each lead or customer their campaign (UTM) tags, See both first and last click attribution.`,
  //       },
  //       {
  //         icon: 'RiGitMergeLine',
  //         heading: 'Auto Form Tracking',
  //         text: `Automatically (or manually) track all form submissions and attach to lead or customer profiles.`,
  //       },
  //       {
  //         icon: 'RiGitMergeLine',
  //         heading: 'GDPR Compliant',
  //         text: `Your audience consists of individual leads, existing customers, named accounts and more. We support all.`,
  //       },
  //       {
  //         icon: 'RiGitMergeLine',
  //         heading: 'Documentation & Tutorials',
  //         text: `Over the years, we have created many different  tutorials, manuals and guidelines. Ready to learn?`,
  //       },
  //       {
  //         icon: 'RiGitMergeLine',
  //         heading: 'Build for Scale',
  //         text: `The more data the better, as we are experts in finding needles in your haystack of lead & customer data.`,
  //       },
  //     ],
  //   },
  //   {
  //     __typename: 'WpPage_Pagebuilder_Layouts_TempFeaturesCta',
  //   },
]
